import { memoize } from "@smithy/property-provider";
import bowser from "bowser";
import { DEFAULTS_MODE_OPTIONS } from "./constants";
export const resolveDefaultsModeConfig = function () {
  let {
    defaultsMode
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return memoize(async () => {
    const mode = typeof defaultsMode === "function" ? await defaultsMode() : defaultsMode;
    switch (mode === null || mode === void 0 ? void 0 : mode.toLowerCase()) {
      case "auto":
        return Promise.resolve(isMobileBrowser() ? "mobile" : "standard");
      case "mobile":
      case "in-region":
      case "cross-region":
      case "standard":
      case "legacy":
        return Promise.resolve(mode === null || mode === void 0 ? void 0 : mode.toLocaleLowerCase());
      case undefined:
        return Promise.resolve("legacy");
      default:
        throw new Error("Invalid parameter for \"defaultsMode\", expect ".concat(DEFAULTS_MODE_OPTIONS.join(", "), ", got ").concat(mode));
    }
  });
};
const isMobileBrowser = () => {
  var _window, _parsedUA$platform;
  const parsedUA = typeof window !== "undefined" && (_window = window) !== null && _window !== void 0 && (_window = _window.navigator) !== null && _window !== void 0 && _window.userAgent ? bowser.parse(window.navigator.userAgent) : undefined;
  const platform = parsedUA === null || parsedUA === void 0 || (_parsedUA$platform = parsedUA.platform) === null || _parsedUA$platform === void 0 ? void 0 : _parsedUA$platform.type;
  return platform === "tablet" || platform === "mobile";
};